import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Sparkles } from 'lucide-react';

const ACCENT_BLUE = 'var(--mc-blue)';

export const Header = ({ showBack = false, onBack }) => {
  const navigate = useNavigate();

  // Quietly only show "Alignment Intelligence" when a relationship is in session
  const relId = typeof window !== 'undefined' ? sessionStorage.getItem('relationship_id') : null;
  const token = typeof window !== 'undefined' ? sessionStorage.getItem('reveal_token') : null;
  const aiHref = relId
    ? `/alignment-intelligence/${relId}${token ? `?token=${token}` : ''}`
    : '/alignment-intelligence';

  return (
    <header className="border-b border-stone-200 bg-background">
      <div className="mx-auto flex w-full max-w-7xl items-center justify-between gap-6 px-6 py-5 md:px-12">
        {/* ── Left: official brand mark + lockup ─────────────────── */}
        <div className="flex items-center gap-4">
          {showBack && (
            <button
              onClick={onBack || (() => navigate(-1))}
              className="rounded-full p-2 text-stone-700 transition-colors hover:bg-stone-100"
              data-testid="back-button"
            >
              <ArrowLeft className="h-5 w-5" />
            </button>
          )}

          <button
            onClick={() => navigate('/')}
            className="flex items-center gap-4 text-left"
            data-testid="brand-lockup"
          >
            {/*
              Official MARRSING® brand mark — open-loop heart enclosing the
              cursive "M" with "MARRSING®" inside. Sourced from the master
              artwork at /public/marrsing-brand-mark-clean.png (transparent PNG).
            */}
            <img
              src="/marrsing-brand-mark-clean.png"
              alt="MARRSING®"
              className="h-14 w-14 sm:h-16 sm:w-16 select-none"
              draggable={false}
              data-testid="marrsing-logo"
            />
            <div className="leading-tight">
              <p
                className="text-[20px] sm:text-[24px] font-medium tracking-tight text-stone-900"
                data-testid="app-title"
              >
                MarrsingClause<span className="text-stone-500">®</span>
              </p>
              <p
                className="mt-1 text-[10px] sm:text-[11px] uppercase tracking-[0.16em]"
                style={{ color: ACCENT_BLUE }}
                data-testid="app-tagline"
              >
                Positive Relationship Transformation
              </p>
            </div>
          </button>
        </div>

        {/* ── Right: subtle nav (always visible across breakpoints) ───── */}
        <div className="flex items-center gap-3 sm:gap-5">
          <button
            onClick={() => navigate(aiHref)}
            className="inline-flex items-center gap-1.5 rounded-full p-2 text-stone-700 transition-colors hover:bg-stone-100 hover:text-stone-900 sm:rounded-none sm:p-0 sm:text-[12px] sm:font-medium sm:tracking-[0.04em] sm:hover:bg-transparent"
            aria-label="Alignment Intelligence"
            title="Alignment Intelligence™"
            data-testid="header-alignment-intelligence-link"
          >
            <Sparkles
              className="h-4 w-4 sm:hidden"
              style={{ color: ACCENT_BLUE }}
              aria-hidden
            />
            <span className="hidden sm:inline">
              Alignment Intelligence<span className="ml-0.5 text-stone-400">™</span>
            </span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
